export const dayNames = ['D', 'L', 'M', 'X', 'J', 'V', 'S']